import { useCallback, useState } from 'react'
import InputField from '../../../components/InputField'
import ApiRoute from '../../../components/ApiRoute'

const Supplemental = ({ callApiFn, isApiCalling }) => {
  const [bidId, setBidId] = useState('')

  const getSupplemental = useCallback(() => {
    callApiFn({
      method: 'GET',
      route: `supplemental/${bidId}`
    })
  }, [bidId])

  return (
    <div className='flex flex-row items-end'>
      <InputField
        labelFor='bidId'
        type='text'
        id='bidId'
        name='bidId'
        onChange={(e) => setBidId(e.target.value)}
        value={bidId}
      >Plan bidId
      </InputField>
      <div className='mx-2'>
        <ApiRoute method='GET' route='/supplemental/{bidId}' onClick={getSupplemental} disabled={isApiCalling || !bidId} />
      </div>
    </div>
  )
}

export default Supplemental
